import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap'
import SelectorLanguage from 'components/common/Selector_Language';
import SelectorDiscipline from 'components/common/selectors/selector-discipline/selectorDiscipline';
import Label, { useLabels } from 'components/general/Label';
import { useGetURL } from 'helpers/urlFriendly';
import { useLocation, Link, useResolvedPath, useParams, useSearchParams } from 'react-router-dom';
import Sprites from "styles/images/SpriteIcons.svg";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import SvgMirs from 'components/presentation/SvgMirs';

//Main Menu
const ElementsNavBar = () => {
    const getURL = useGetURL()
    let params = useUrlFriendlyToParameters()//useParams();

    let paramsRecords = { ...params };
    paramsRecords["mirs_discipline"] = "";

    //Copy object in order to change 
    let paramsURL = { ...params };

    paramsURL["mirs_date"] = "";
    paramsURL["mirs_discipline"] = "";
    paramsURL["mirs_event"] = "";
    paramsURL["mirs_noc"] = "";
    paramsURL["mirs_medal"] = "";

    //Change object if make changes over params make changes in componets related   (Change URL object)
    let urlAthletes = getURL(paramsURL, 'athletes')
    let urlCompetitionSchedule = getURL(paramsURL, 'competitionschedule')
    let urlMedal = getURL(paramsURL, 'medal')
    let urlRecords = getURL(paramsRecords, 'records')

    return (
        <>
            <Nav.Link as={CustomLink} to={urlCompetitionSchedule}><Label data={'ScheduleSort'} /></Nav.Link>
            <Nav.Link as={CustomLink} to={urlAthletes}><Label data={'LabelAthletes'} /></Nav.Link>
            <SelectorDiscipline page="schedule" />
            <Nav.Link as={CustomLink} to={urlRecords}><Label data={'LabelRecords'} /></Nav.Link>
            <Nav.Link as={CustomLink} to={urlMedal}><Label data={'LabelMedals'} /></Nav.Link>
        </>
    )
}

//HOC (Higth Order Component) component Link in order to style selected 
function CustomLink({ children, to, ...props }) {
    let resolved = useResolvedPath(to);
    //let match = useMatch({ path: resolved.pathname, end: true });
    return (
        <div className="nav-schedule" >
            <Link
                to={to}
                {...props}
            >
                {children}
            </Link>
            {/* {match && " (active)"}*/}
        </div>
    );
}

export function HeaderDefault() {
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const fLabel = useLabels()

    //Theme Button 

    const bodyTheme = () => {
        let swDark = (/true/i).test(searchParams.get('displayAsWebViewdark'));
        setSearchParams({ displayAsWebViewdark: !swDark })
    }

    return (
        <Navbar expand="lg" id="mirs-first-navigation-bar" aria-labelledby="NavBarHeader">
            <span id="NavBarHeader" className="d-none"><Label data={'LabelGlobalNav'} /></span>
            <Container>
                <Navbar.Brand href="#schedule" className="d-flex">
                    <div className="brand">M.I.R.S. Application</div>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="navbar-main" />
                <Navbar.Collapse id="navbar-main">
                    <Nav activeKey={""} active={location.pathname} className="ms-auto mb-2 mb-lg-0">
                        <ElementsNavBar />
                    </Nav>
                    <SelectorLanguage />

                    <button className='mirsIconThemeColor' id='themeButton' aria-label={fLabel({ data: "HeaderSwitchTheme" })} onClick={bodyTheme} >
                        <SvgMirs className='mirsIconThemeColor' code='themecolor' />
                    </button>

                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
};
export default HeaderDefault